import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_8 = { class: "flex justify-end" }
const _hoisted_9 = {
  key: 0,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs text-gray-500 ml-1"
}
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "flex space-x-4 flex-1" }
const _hoisted_15 = { class: "text-left text-gray-700" }
const _hoisted_16 = { class: "text-sm font-medium leading-none" }
const _hoisted_17 = { class: "text-sm text-gray-500" }
const _hoisted_18 = { class: "text-xs text-gray-500" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "h-12 mr-2"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "text-left transition-colors duration-150 text-gray-700 hover:text-blue-600 flex-1" }
const _hoisted_23 = { class: "flex items-center gap-1.5" }
const _hoisted_24 = { class: "text-md font-medium truncate" }
const _hoisted_25 = {
  key: 0,
  class: "ml-1 text-sm"
}
const _hoisted_26 = { class: "text-sm text-gray-700" }

import { MenuItem } from '@headlessui/vue'
import { CheckIcon, XMarkIcon } from '@heroicons/vue/20/solid'
import { Bars3Icon, XCircleIcon } from '@heroicons/vue/24/outline'
import Sortable from 'sortablejs'
import { computed, inject, onMounted, ref, watch } from 'vue'

import EmptyState from '@/components/neue/EmptyState'
import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueTablist from '@/components/neue/NeueTablist'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'


export default {
  __name: 'StoreUpsells',
  props: ['id'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const props = __props

const cols = [{ width: 'minmax(220px, 2fr)' }, { width: 'minmax(140px, 1fr)' }, { width: '130px' }]

// TODO(alicja): ideally should be declarative
const upsells = ref(null)
const pairs = computed(() =>
  mapRelationships(mapRelationship(upsells.value)?.relationships.category_product_store_pairs.data).sort(
    (a, b) => a.attributes.order - b.attributes.order
  )
)
const product = pair => mapRelationship(pair.relationships.product.data)
const image = product => mapRelationships(product.relationships.attachments.data)[0]?.attributes.secure_url
const hasCustomPrices = pair =>
  mapRelationships(pair.relationships.product_store_membership_prices.data).some(x => !x.attributes.use_default_price)

const addModal = ref({ open: false })
const pairModal = ref({ open: false })

const headerText = ref('')
const buttonText = ref('')

const rows = ref(null)

watch(rows, () => {
  if (rows.value)
    new Sortable(rows.value, {
      handle: '.cursor-move',
      ghostClass: 'bg-gray-200',
      dragClass: 'bg-white',
      onSort(e) {
        const list = pairs.value
        const moved = list.splice(e.oldIndex, 1)[0]
        list.splice(e.newIndex, 0, moved)
        api.call('PUT', `stores/${props.id}/categories/${upsells.value.id}`, {
          category: {
            category_product_store_pairs_attributes: list.map((x, i) => ({
              id: x.id,
              order: i
            }))
          }
        })
      }
    })
})

const loadTexts = () => {
  headerText.value = upsells.value?.attributes.upsell_header_text
  buttonText.value = upsells.value?.attributes.upsell_button_text
}

onMounted(async () => {
  await api
    .call(
      'GET',
      `stores/${props.id}/categories/upsells?included=category_product_store_pairs,category_product_store_pairs.product_store_membership_prices,products,products.attachments`
    )
    .then(response => {
      upsells.value = response.data.data
      loadTexts()
    })
  loading.value = false
})

const addProducts = () => {
  addModal.value = {
    open: true,
    searchQuery: '',
    searchResults: [],
    selectedProducts: []
  }
}

const saveAddModal = () => {
  for (const product of addModal.value.selectedProducts) {
    api.call('POST', `stores/${props.id}/category_product_store_pairs`, {
      category_product_store_pair: {
        category_id: upsells.value.id,
        product_id: product.id,
        default_upsell_price_cents: null
      }
    })
  }
  addModal.value.open = false
}

const editPair = pair => {
  pairModal.value = {
    open: true,
    mode: 'edit',
    pair,
    discountPrice:
      pair.attributes.default_upsell_price_cents === null
        ? null
        : (pair.attributes.default_upsell_price_cents / 100).toFixed(2)
  }
}

const toggleDiscountPrice = enable => {
  if (enable) {
    pairModal.value.discountPrice = (product(pairModal.value.pair).attributes.default_price.cents / 100).toFixed(2)
  } else {
    pairModal.value.discountPrice = null
  }
}

const savePairModal = () => {
  api.call('PUT', `stores/${props.id}/category_product_store_pairs/${pairModal.value.pair.id}`, {
    category_product_store_pair: {
      default_upsell_price_cents: pairModal.value.discountPrice ? pairModal.value.discountPrice * 100 : null
    }
  })
  pairModal.value.open = false
}

const deletePair = pair => {
  if (!confirm(`Delete ${product(pair).attributes.product_name}?`)) return
  api.call('DELETE', `stores/${props.id}/category_product_store_pairs/${pair.id}`, {}, { delete: false })
}

const dirty = () => bus.emit('dirty/store', { from: 'upsells' })

bus.on('save/store', () => {
  if (!upsells.value) return
  api.call('PUT', `stores/${props.id}/categories/${upsells.value.id}?included=none`, {
    category: {
      upsell_header_text: headerText.value,
      upsell_button_text: buttonText.value
    }
  })
})

bus.on('discard/store', loadTexts)

return (_ctx, _cache) => {
  const _component_InlineSearchSelect = _resolveComponent("InlineSearchSelect")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_router_link = _resolveComponent("router-link")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NeueLoading), { loading: loading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SettingsSection, {
            title: "Products to offer",
            description: "Shown as a final step before checkout. Click a product in the list to give it a discounted upsell price.",
            plain: ""
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(NeueTablist), null, {
                  head: _withCtx(() => [
                    _createVNode(_unref(TablistHeader), null, {
                      default: _withCtx(() => [
                        _createVNode(TablistGrid, {
                          columns: cols,
                          header: "",
                          class: "items-center"
                        }, {
                          default: _withCtx(() => [
                            _cache[11] || (_cache[11] = _createElementVNode("div", null, "Product", -1)),
                            _cache[12] || (_cache[12] = _createElementVNode("div", null, "Price", -1)),
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_unref(NeueButton), {
                                type: "secondary",
                                class: "whitespace-nowrap",
                                onClick: addProducts
                              }, {
                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                  _createTextVNode("+ Products", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      ref_key: "rows",
                      ref: rows,
                      class: "divide-y divide-gray-200"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pairs.value, (pair) => {
                        return (_openBlock(), _createBlock(_unref(TablistRow), {
                          key: pair.id,
                          class: "cursor-pointer",
                          onClick: $event => (editPair(pair))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: cols,
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("div", {
                                    class: "cursor-move -ml-4 px-3 -mt-2 -mb-2 py-2",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                  ]),
                                  _createElementVNode("span", _hoisted_5, _toDisplayString(product(pair).attributes.product_name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _withDirectives((_openBlock(), _createElementBlock("span", {
                                    class: _normalizeClass(["text-sm", pair.attributes.default_upsell_price_cents !== null && 'line-through'])
                                  }, [
                                    _createTextVNode(_toDisplayString(product(pair).attributes.default_price.format) + _toDisplayString(hasCustomPrices(pair) ? '*' : ''), 1)
                                  ], 2)), [
                                    [_directive_tippy, {
                        content: hasCustomPrices(pair)
                          ? 'Default price (some membership tiers use a different price)'
                          : 'Default price'
                      }]
                                  ]),
                                  (pair.attributes.default_upsell_price_cents !== null)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
                                        _createTextVNode(" $" + _toDisplayString((pair.attributes.default_upsell_price_cents / 100).toFixed(2)), 1)
                                      ])), [
                                        [_directive_tippy, { content: 'Discounted upsell price' }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_unref(XCircleIcon), {
                                    class: "cursor-pointer h-6 w-6 hover:text-black shrink-0",
                                    onClick: _withModifiers($event => (deletePair(pair)), ["stop"])
                                  }, null, 8, ["onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ], 512)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, pairs.value.length]
              ]),
              (!pairs.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_unref(EmptyState), {
                      plural: "upsells",
                      description: "Display upsells to your customers by selecting at least one product from your library."
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NeueButton), {
                          type: "secondary",
                          onClick: addProducts
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("+ Products", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(SettingsSection, {
            title: "Page wording",
            description: "What customers read on the upsell screen. Leave either blank to use the default wording."
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputField), {
                modelValue: headerText.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((headerText).value = $event)),
                name: "Upsell page header",
                placeholder: "Complete your cart with these discounted offers, just for you.",
                description: "Defaults to \"Complete your cart\".",
                onInput: dirty
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(InputField), {
                modelValue: buttonText.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((buttonText).value = $event)),
                name: "Continue button text (no upsells)",
                placeholder: "Continue without claiming these offers",
                description: "Shown when no upsells have been added to the cart. Defaults to \"No thanks\".",
                onInput: dirty
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_TheModal, {
      "is-open": addModal.value.open,
      "modal-title": "Add products",
      onCloseModal: _cache[6] || (_cache[6] = $event => (addModal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_component_InlineSearchSelect, {
          "helper-text": {
          noResult: 'No results found',
          noneSelected: 'Select items',
          typingPrompt: 'Chicken Parmesan'
        },
          "search-endpoint": "products/search",
          "search-request": { query: addModal.value.searchQuery },
          onOnSearch: _cache[3] || (_cache[3] = x => (addModal.value.searchQuery = x)),
          onOnResults: _cache[4] || (_cache[4] = x => (addModal.value.searchResults = x))
        }, {
          searchResults: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addModal.value.searchResults, (item) => {
              return (_openBlock(), _createBlock(_unref(MenuItem), {
                key: item.id,
                class: "z-10"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: _normalizeClass([
                addModal.value.selectedProducts.some(x => x.id == item.id) ? 'text-gray-300' : 'text-gray-700',
                'group rounded-md w-full px-2 py-2 text-sm text-left hover:bg-gray-100 duration-200 transition-colors'
              ]),
                    disabled: addModal.value.selectedProducts.some(x => x.id == item.id),
                    onClick: _withModifiers($event => (addModal.value.selectedProducts.push(item)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.attributes.product_name), 1),
                    (item.attributes.description)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " — " + _toDisplayString(item.attributes.description), 1))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_10)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          selectedItems: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addModal.value.selectedProducts, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: "group py-2 mt-2 px-2 duration-150 transition-colors hover:bg-gray-100"
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(CheckIcon), { class: "w-4 h-4 rounded-full mr-2 text-gray-700" }),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", _hoisted_16, _toDisplayString(item.attributes.product_name), 1),
                        _createElementVNode("p", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(item.attributes.description), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _withModifiers($event => (addModal.value.selectedProducts = addModal.value.selectedProducts.filter(x => x.id !== item.id)), ["prevent"])
                    }, [
                      _createVNode(_unref(XMarkIcon), { class: "w-4 h-4 rounded-full mr-2 text-gray-700" })
                    ], 8, _hoisted_19)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["search-request"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[5] || (_cache[5] = $event => (addModal.value.open = false))
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(NeueButton), {
          type: addModal.value.selectedProducts.length ? 'primary' : 'inactive',
          onClick: saveAddModal
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createTextVNode(" Save ", -1)
          ]))]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_TheModal, {
      "is-open": pairModal.value.open,
      onCloseModal: _cache[9] || (_cache[9] = $event => (pairModal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: `/store/products/${product(pairModal.value.pair).id}`,
          class: "flex mb-8",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            (image(product(pairModal.value.pair)))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("img", {
                    class: "w-full h-full object-center object-cover rounded select-none",
                    src: image(product(pairModal.value.pair))
                  }, null, 8, _hoisted_21)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("p", _hoisted_24, _toDisplayString(product(pairModal.value.pair).attributes.product_name), 1),
                _cache[16] || (_cache[16] = _createElementVNode("div", null, "•", -1)),
                _createElementVNode("div", null, [
                  _withDirectives((_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["text-sm", pairModal.value.discountPrice && 'line-through'])
                  }, [
                    _createTextVNode(_toDisplayString(product(pairModal.value.pair).attributes.default_price.format) + _toDisplayString(hasCustomPrices(pairModal.value.pair) ? '*' : ''), 1)
                  ], 2)), [
                    [_directive_tippy, {
                  content: hasCustomPrices(pairModal.value.pair)
                    ? 'Default price (some membership tiers use a different price)'
                    : 'Default price'
                }]
                  ]),
                  (pairModal.value.discountPrice)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_25, [
                        _createTextVNode(" $" + _toDisplayString(pairModal.value.discountPrice), 1)
                      ])), [
                        [_directive_tippy, {
                  content: 'Discounted upsell price'
                }]
                      ])
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("p", _hoisted_26, _toDisplayString(product(pairModal.value.pair).attributes.description), 1),
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-sm mt-2" }, "View in product library →", -1))
            ])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(FormSection), { name: "Upsell settings" }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_NeueToggle, {
                  name: "Discount price",
                  class: "mb-2",
                  "model-value": pairModal.value.discountPrice !== null,
                  onChange: toggleDiscountPrice
                }, null, 8, ["model-value"]),
                (pairModal.value.discountPrice !== null)
                  ? (_openBlock(), _createBlock(_unref(InputField), {
                      key: 0,
                      modelValue: pairModal.value.discountPrice,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((pairModal.value.discountPrice) = $event)),
                      prefix: "$"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[8] || (_cache[8] = $event => (pairModal.value.open = false))
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(NeueButton), {
          type: "primary",
          onClick: savePairModal
        }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

}